import {
  addDays,
  addHours,
  addMonths,
  addWeeks,
  addYears,
  differenceInDays,
  differenceInMinutes,
  formatDistanceToNow,
} from 'date-fns';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FsTimeService {
  constructor() {}

  public convertToUnixTimestampSeconds(date: Date): number {
    return Math.floor(date.getTime() / 1000);
  }

  public convertToUnixTimestampMilliseconds(date: Date): number {
    return Math.floor(date.getTime());
  }

  public convertToDateSeconds(unixTimestamp: number): Date {
    return new Date(unixTimestamp * 1000);
  }

  public convertToDateMilliseconds(unixTimestamp: number): Date {
    return new Date(unixTimestamp);
  }

  public daysBetween(unixTimestampTo: number, unixTimestampFrom: number): number {
    const startDate = this.convertToDateSeconds(unixTimestampTo);
    const endDate = this.convertToDateSeconds(unixTimestampFrom);
    return differenceInDays(startDate, endDate);
  }

  public distanceToNow(date: Date): string {
    return formatDistanceToNow(date);
  }

  public minutesSinceUnix(unixTimestamp: number): number {
    return differenceInMinutes(new Date(), unixTimestamp);
  }

  public yearMonthDayFormat(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month}-${day}`;
  }

  public getXHoursAgo(x: number): Date {
    return addHours(new Date(), -x);
  }

  public getXDaysAgo(x: number): Date {
    return addDays(new Date(), -x);
  }

  public getXFutureDays(x: number): Date {
    return addDays(new Date(), x);
  }

  public getXWeeksAgo(x: number): Date {
    return addWeeks(new Date(), -x);
  }

  public getXFutureWeeks(x: number): Date {
    return addWeeks(new Date(), x);
  }

  public getXMonthsAgo(x: number): Date {
    return addMonths(new Date(), -x);
  }

  public getXFutureMonths(x: number): Date {
    return addWeeks(new Date(), x);
  }

  public getXYearsAgo(x: number): Date {
    return addYears(new Date(), -x);
  }

  public getXFutureYears(x: number): Date {
    return addWeeks(new Date(), x);
  }
}
